import { createApi } from "@/api/ApiFactory";
import { config } from "@/config/config";

const GraphApi = createApi(config.GRAPH_API_URL);

export default GraphApi;
